var navDetection = (function () {

	function init() {
		var header = document.querySelector('header');
		var nav = header.querySelector('nav');

		if(typeof(nav) !== 'undefined' && nav !== null){
			return;
		} else {
			if (header) {
				header.classList.add('global-header--without-nav');
			}
		}
	}

	return {
		init: init	
	  };
})();

document.addEventListener('DOMContentLoaded', function () {
	navDetection.init();
});
